const $ = require("jquery");
$('.rooms').each(function () {
    let $rooms = $(this),
        $tabs = $('.rooms__tabs .tab', this),
        $tabPanels = $('.rooms__tab-content .tab-panel', this);

    // set current active room
    if (!$('.rooms__tabs .tab[data-state="active"]', this).length > 0) {
        $tabs.first().attr('data-state', 'active');
        $tabPanels.first().attr('data-state', 'active');
    }

    $tabs.on('click', function() {
        let roomID = $(this).data('room-id'),
            $panel = $rooms.find('.tab-panel[data-room-id="' + roomID + '"]');

        if ('active' !== $(this).attr('data-state')) {
            $(this).attr('data-state', 'active').siblings('.tab').removeAttr('data-state');
            $panel.attr('data-state', 'active').siblings('.tab-panel').removeAttr('data-state');

            $panel.find('.slick-slider').slick('refresh');
        }

        $(this).blur();

        if (viewport().width < 768) {
            $('html, body').stop().animate({
                scrollTop: $rooms.find('.rooms__tab-content').offset().top - $('header[role="masthead"] .top-bar').outerHeight() - 20
            }, 500, 'easeInOutCubic');
        }
    });
});
